// extracted by mini-css-extract-plugin
export var footer = "index-module--footer--2eS0J";
export var header = "index-module--header--2sw5E";